import { Role } from "@/types/common";

export type Permission =
  | "view_own_profile"
  | "edit_own_profile"
  | "view_directory"
  | "request_leave"
  | "log_time"
  | "submit_complaint"
  | "view_team"
  | "approve_team_leave"
  | "approve_timesheets"
  | "write_reviews"
  | "manage_employees"
  | "view_all_employees"
  | "manage_complaints"
  | "view_all_complaints"
  | "manage_documents"
  | "view_reports"
  | "manage_invoices"
  | "manage_org_settings"
  | "manage_departments"
  | "view_audit_log"
  | "manage_billing";

const EMPLOYEE_PERMS: Set<Permission> = new Set([
  "view_own_profile",
  "edit_own_profile",
  "view_directory",
  "request_leave",
  "log_time",
  "submit_complaint",
]);

const MANAGER_PERMS: Set<Permission> = new Set([
  ...EMPLOYEE_PERMS,
  "view_team",
  "approve_team_leave",
  "approve_timesheets",
  "write_reviews",
]);

const HR_ADMIN_PERMS: Set<Permission> = new Set([
  ...MANAGER_PERMS,
  "manage_employees",
  "view_all_employees",
  "manage_complaints",
  "view_all_complaints",
  "manage_documents",
  "view_reports",
  "manage_invoices",
]);

const SUPER_ADMIN_PERMS: Set<Permission> = new Set([
  ...HR_ADMIN_PERMS,
  "manage_org_settings",
  "manage_departments",
  "view_audit_log",
  "manage_billing",
]);

export const ROLE_PERMISSIONS: Record<Role, Set<Permission>> = {
  EMPLOYEE: EMPLOYEE_PERMS,
  MANAGER: MANAGER_PERMS,
  HR_ADMIN: HR_ADMIN_PERMS,
  SUPER_ADMIN: SUPER_ADMIN_PERMS,
};
